export interface UserTerms {
  agreement1: boolean; // privacy
  agreement2: boolean; // terms
  agreement3: boolean; // newsletter
}
